module.exports = __webpack_public_path__ + "img/livey.8b1f7b13.png";